(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["velune-free-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
  var DECIMALS = { JPY: 0, KRW: 0, VND: 0, ISK: 0, CLP: 0, HUF: 0 };

  function decimalsFor(code) {
    if (code && Object.prototype.hasOwnProperty.call(DECIMALS, code)) {
      return DECIMALS[code];
    }
    return 2;
  }

  function toYen(totalMinor, code) {
    var d = decimalsFor(code);
    if (d === 0) return totalMinor;
    return totalMinor / Math.pow(10, d);
  }

  function formatYen(n) {
    try {
      return '¥' + Math.round(n).toLocaleString('ja-JP');
    } catch (e) {
      return '¥' + Math.round(n);
    }
  }

  function render(root, totalYen) {
    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 10000;
    var fill = root.querySelector('[data-ship-fill]');
    var remaining = root.querySelector('[data-ship-remaining]');
    var headline = root.querySelector('[data-ship-headline]');

    if (totalYen === null || isNaN(totalYen) || totalYen <= 0) {
      root.classList.remove('is-qualified');
      if (fill) fill.style.width = '0%';
      if (remaining) {
        remaining.hidden = true;
        remaining.textContent = '';
      }
      if (headline) {
        headline.textContent = '¥' + threshold.toLocaleString('ja-JP') + '以上のご購入で送料無料';
      }
      return;
    }

    var pct = Math.max(0, Math.min(100, (totalYen / threshold) * 100));
    if (fill) fill.style.width = pct + '%';

    if (totalYen >= threshold) {
      root.classList.add('is-qualified');
      if (remaining) {
        remaining.hidden = false;
        remaining.textContent = '送料無料が適用されます';
      }
    } else {
      root.classList.remove('is-qualified');
      var left = threshold - totalYen;
      if (remaining) {
        remaining.hidden = false;
        remaining.innerHTML =
          'あと<span class="velune-ship__amount">' +
          formatYen(left) +
          '</span>で送料無料';
      }
    }
  }

  function fetchCart(root) {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart unavailable');
        return res.json();
      })
      .then(function (cart) {
        var code = cart.currency ||
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
        render(root, toYen(cart.total_price, code));
      })
      .catch(function () {
        render(root, null);
      });
  }

  function refetchAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-velune-ship]'),
      function (root) { fetchCart(root); }
    );
  }

  function init() {
    var roots = document.querySelectorAll('[data-velune-ship]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      fetchCart(root);
    });

    // Re-check after add-to-cart form submits (delay lets Shopify update the cart).
    document.addEventListener('submit', function (e) {
      var form = e.target;
      var action = form && form.getAttribute && form.getAttribute('action');
      if (action && action.indexOf('/cart/add') !== -1) {
        setTimeout(refetchAll, 600);
      }
    });

    // Common Rise cart events.
    document.addEventListener('cart:updated', refetchAll);
    document.addEventListener('cart:refresh', refetchAll);
    document.addEventListener('cart:change', refetchAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["velune-size-diagnosis"] && !Shopify.designMode) return;
  try {
    /* ==========================================================================
     VELUNE SIZE DIAGNOSIS — recommender + widget controller
     This block runs once globally and contains NO Liquid.
     Each .vl-sizedx-root reads its own model from the inline
     <script type="application/json" class="vl-sizedx-data"> child.
     ========================================================================== */

  var velune_msg = {
    good: function (s) { return "身長・体重ともに " + s + " サイズの目安に収まっています。ゆったりとお過ごしいただけます。"; },
    betweenLarger: function (s) { return "ちょうど境目のため、心地よいゆとりのある " + s + " をおすすめします。"; },
    betweenSmaller: function (s) { return "体重の目安から、すっきりとした " + s + " をおすすめします。"; },
    oneDim: function (s) { return s + " サイズが最も近い目安です。着心地はゆったりめになります。"; },
    nominal: function (s) { return "身長の目安から " + s + " サイズがちょうどよいかと思います。"; },
    nominalNoHeight: function () { return "この商品は身長を目安にサイズを選んでいます。身長をご入力ください。"; },
    weightNeeded: function () { return "この商品は体重を目安にサイズを選んでいます。体重をご入力ください。"; },
    needGender: function () { return "この商品はメンズ・レディースでサイズが異なります。性別をお選びください。"; },
    tooSmallH: function (s) { return "サイズ表より小柄なため、最も小さい " + s + " をおすすめします。ゆとりが出やすい点はご了承ください。"; },
    tooLargeH: function (s) { return "サイズ表より高身長のため、最も大きい " + s + " をおすすめします。着丈が短めに出ることがあります。"; },
    tooSmallW: function (s) { return "サイズ表より軽やかなため、最も小さい " + s + " をおすすめします。ゆとりが出やすい点はご了承ください。"; },
    tooLargeW: function (s) { return "サイズ表の上限を超えるため、最も大きい " + s + " をおすすめします。着心地がタイトになる場合があります。"; },
    noInput: function () { return "身長と体重をご入力のうえ、診断するを押してください。"; },
    noData: function () { return "この商品はサイズ診断の対象外です。サイズ表をご参照ください。"; }
  };

  /**
   * VELUNE SIZE DIAGNOSIS — recommendSize()  (repaired)
   */
  function recommendSize(model, input) {
    var gender = input && input.gender;
    var heightCm = input && input.heightCm != null ? Number(input.heightCm) : null;
    var weightKg = input && input.weightKg != null ? Number(input.weightKg) : null;
    if (heightCm !== null && !(heightCm > 0)) heightCm = null;
    if (weightKg !== null && !(weightKg > 0)) weightKg = null;

    var msg = velune_msg;
    var sizes = model.sizes || {};
    var ORDER = { S: 0, M: 1, L: 2 };

    var rows;
    var needGender = false;
    if (model.genderMode === "dual") {
      var wRows = sizes.W || [];
      var mRows = sizes.M || [];
      var chartsDiffer = JSON.stringify(wRows) !== JSON.stringify(mRows);
      if (gender === "M") rows = mRows.length ? mRows : wRows;
      else if (gender === "W") rows = wRows.length ? wRows : mRows;
      else {
        if (wRows.length && mRows.length && chartsDiffer) needGender = true;
        rows = wRows.length ? wRows : mRows;
      }
    } else {
      rows = sizes.X || sizes.W || sizes.M || [];
    }
    rows = (rows || []).slice().sort(function (a, b) { return ORDER[a.size] - ORDER[b.size]; });

    if (!rows.length) {
      return { size: "M", confidence: "outside", message: msg.noData() };
    }
    if (needGender) {
      return { size: rows[Math.floor(rows.length / 2)].size, confidence: "outside", message: msg.needGender() };
    }
    if (heightCm === null && weightKg === null) {
      return { size: rows[Math.floor(rows.length / 2)].size, confidence: "outside", message: msg.noInput() };
    }

    var hasHeight = rows.some(function (r) { return r.hMin != null || r.hMax != null; });
    var hasWeight = rows.some(function (r) { return r.wMin != null || r.wMax != null; });
    var allNominal = rows.every(function (r) { return r.nominal; });

    var weightCapOnly = !hasHeight && hasWeight &&
      rows.every(function (r) { return r.wMin == null && r.wMax != null; });
    if (weightCapOnly) {
      if (weightKg === null) {
        return { size: rows[Math.floor(rows.length / 2)].size, confidence: "outside", message: msg.weightNeeded() };
      }
      for (var ci = 0; ci < rows.length; ci++) {
        if (weightKg <= rows[ci].wMax) {
          return { size: rows[ci].size, confidence: "good", message: msg.good(rows[ci].size) };
        }
      }
      var lastCap = rows[rows.length - 1];
      return { size: lastCap.size, confidence: "outside", message: msg.tooLargeW(lastCap.size) };
    }

    if (hasWeight && !hasHeight && weightKg === null) {
      return { size: rows[Math.floor(rows.length / 2)].size, confidence: "outside", message: msg.weightNeeded() };
    }

    if (allNominal) {
      if (heightCm === null) {
        return { size: rows[Math.floor(rows.length / 2)].size, confidence: "outside", message: msg.nominalNoHeight() };
      }
      var best = null, bestD = Infinity;
      for (var i = 0; i < rows.length; i++) {
        var pt = rows[i].hMin != null ? rows[i].hMin : rows[i].hMax;
        var mid = (rows[i].hMin != null && rows[i].hMax != null) ? (rows[i].hMin + rows[i].hMax) / 2 : pt;
        var d = Math.abs(heightCm - mid);
        if (d <= bestD) { bestD = d; best = rows[i]; }
      }
      var loN = rows[0], hiN = rows[rows.length - 1];
      var loEdge = loN.hMin, hiEdge = hiN.hMax != null ? hiN.hMax : hiN.hMin;
      if (heightCm < loEdge - 8) return { size: loN.size, confidence: "outside", message: msg.tooSmallH(loN.size) };
      if (heightCm > hiEdge + 8) return { size: hiN.size, confidence: "outside", message: msg.tooLargeH(hiN.size) };
      return { size: best.size, confidence: "close", message: msg.nominal(best.size) };
    }

    var useWeight = hasWeight && weightKg !== null && (!hasHeight || heightCm === null);
    var useHeight = hasHeight && heightCm !== null && !useWeight;
    if (!useWeight && !useHeight) {
      if (hasWeight && weightKg !== null) useWeight = true;
      else if (hasHeight && heightCm !== null) useHeight = true;
    }

    function score(r) {
      var s = { hIn: null, wIn: null, hDist: 0, wDist: 0, hHas: false, wHas: false };
      if (heightCm !== null && (r.hMin != null || r.hMax != null)) {
        s.hHas = true;
        var lo = r.hMin != null ? r.hMin : -Infinity;
        var hi = r.hMax != null ? r.hMax : Infinity;
        if (heightCm >= lo && heightCm <= hi) { s.hIn = true; }
        else { s.hIn = false; s.hDist = heightCm < lo ? lo - heightCm : heightCm - hi; }
      }
      if (weightKg !== null && (r.wMin != null || r.wMax != null)) {
        s.wHas = true;
        var wlo = r.wMin != null ? r.wMin : -Infinity;
        var whi = r.wMax != null ? r.wMax : Infinity;
        if (weightKg >= wlo && weightKg <= whi) { s.wIn = true; }
        else { s.wIn = false; s.wDist = weightKg < wlo ? wlo - weightKg : weightKg - whi; }
      }
      return s;
    }

    var scored = rows.map(function (r) { return { row: r, s: score(r) }; });

    if (useWeight) {
      var wRowsScored = scored.filter(function (x) { return x.s.wHas; });
      if (!wRowsScored.length) {
        useWeight = false; useHeight = hasHeight && heightCm !== null;
      } else {
        wRowsScored.sort(function (a, b) { return ORDER[a.row.size] - ORDER[b.row.size]; });
        var contained = wRowsScored.filter(function (x) { return x.s.wIn === true; });
        var wLo = null, wHi = null;
        for (var k = 0; k < wRowsScored.length; k++) {
          var rr = wRowsScored[k].row;
          if (rr.wMin != null && (wLo === null || rr.wMin < wLo)) wLo = rr.wMin;
          if (rr.wMax != null && (wHi === null || rr.wMax > wHi)) wHi = rr.wMax;
        }
        var below = wLo != null && weightKg < wLo;
        var above = wHi != null && weightKg > wHi;

        if (contained.length) {
          var smallerC = contained[0], largerC = contained[contained.length - 1];
          if (contained.length > 1) {
            var lw = largerC.row.wMin;
            if (smallerC.s.wIn === true && lw != null && weightKg < lw) {
              return { size: smallerC.row.size, confidence: "close", message: msg.betweenSmaller(smallerC.row.size) };
            }
            return { size: largerC.row.size, confidence: "close", message: msg.betweenLarger(largerC.row.size) };
          }
          var onlyC = contained[0];
          var conf = (onlyC.s.hHas && onlyC.s.hIn === false) ? "close" : "good";
          var m2 = conf === "good" ? msg.good(onlyC.row.size) : msg.oneDim(onlyC.row.size);
          return { size: onlyC.row.size, confidence: conf, message: m2 };
        }
        if (below) {
          return { size: wRowsScored[0].row.size, confidence: "outside", message: msg.tooSmallW(wRowsScored[0].row.size) };
        }
        if (above) {
          return { size: wRowsScored[wRowsScored.length - 1].row.size, confidence: "outside", message: msg.tooLargeW(wRowsScored[wRowsScored.length - 1].row.size) };
        }
        var bW = null, bWD = Infinity;
        for (var g = 0; g < wRowsScored.length; g++) {
          if (wRowsScored[g].s.wDist <= bWD) { bWD = wRowsScored[g].s.wDist; bW = wRowsScored[g]; }
        }
        return { size: bW.row.size, confidence: "close", message: msg.betweenLarger(bW.row.size) };
      }
    }

    var perfect = scored.filter(function (x) {
      var okH = x.s.hIn === true || x.s.hIn === null;
      var okW = x.s.wIn === true || x.s.wIn === null;
      var touched = x.s.hHas || x.s.wHas;
      return touched && okH && okW && (x.s.hIn === true || x.s.wIn === true);
    });

    if (perfect.length === 1) {
      return { size: perfect[0].row.size, confidence: "good", message: msg.good(perfect[0].row.size) };
    }
    if (perfect.length > 1) {
      perfect.sort(function (a, b) { return ORDER[a.row.size] - ORDER[b.row.size]; });
      var smaller = perfect[0], larger = perfect[perfect.length - 1];
      if (weightKg !== null && smaller.s.wHas && larger.s.wHas) {
        var lw2 = larger.row.wMin;
        if (smaller.s.wIn === true && lw2 != null && weightKg < lw2) {
          return { size: smaller.row.size, confidence: "close", message: msg.betweenSmaller(smaller.row.size) };
        }
      }
      return { size: larger.row.size, confidence: "close", message: msg.betweenLarger(larger.row.size) };
    }

    var containedH = scored.filter(function (x) { return x.s.hIn === true; });
    if (containedH.length) {
      containedH.sort(function (a, b) { return ORDER[a.row.size] - ORDER[b.row.size]; });
      var pickC = containedH[containedH.length - 1];
      return { size: pickC.row.size, confidence: "close", message: msg.oneDim(pickC.row.size) };
    }
    var lowEdge = rows[0].hMin;
    var hiRow = rows[rows.length - 1];
    var highEdge = hiRow.hMax != null ? hiRow.hMax : hiRow.hMin;
    scored.sort(function (a, b) { return ORDER[a.row.size] - ORDER[b.row.size]; });
    if (lowEdge != null && heightCm < lowEdge) {
      return { size: scored[0].row.size, confidence: "outside", message: msg.tooSmallH(scored[0].row.size) };
    }
    if (highEdge != null && heightCm > highEdge) {
      return { size: scored[scored.length - 1].row.size, confidence: "outside", message: msg.tooLargeH(scored[scored.length - 1].row.size) };
    }
    var bestH = null, bestHD = Infinity;
    for (var j = 0; j < scored.length; j++) {
      if (scored[j].s.hDist <= bestHD) { bestHD = scored[j].s.hDist; bestH = scored[j]; }
    }
    return { size: bestH.row.size, confidence: "close", message: msg.betweenLarger(bestH.row.size) };
  }

  var VeluneSizeDiagnosis = {
    init: function (root) {
      if (!root || root.__veluneInited) return;

      // Read this root's model from its inline JSON data script.
      var dataEl = root.querySelector(".vl-sizedx-data");
      var model = null;
      if (dataEl) {
        try { model = JSON.parse(dataEl.textContent || "null"); } catch (err) { model = null; }
      }
      if (!model) return;
      root.__veluneModel = model;
      root.__veluneInited = true;

      var overlay = root.querySelector(".vl-sizedx-overlay");
      var modal = root.querySelector(".vl-sizedx-modal");
      var trigger = root.querySelector(".vl-sizedx-trigger");
      var closeBtn = root.querySelector(".vl-sizedx-close");
      var form = root.querySelector(".vl-sizedx-form");
      var genderField = root.querySelector('[data-role="gender"]');
      var genderHint = root.querySelector('[data-role="gender-hint"]');
      var seg = root.querySelector(".vl-sizedx-seg");
      var result = root.querySelector(".vl-sizedx-result");
      var redo = root.querySelector(".vl-sizedx-redo");
      var lastFocus = null;

      function currentModel() { return root.__veluneModel; }
      function isDualNow() { var m = currentModel(); return m && m.genderMode === "dual"; }

      // Gender toggle is shown ONLY for dual-chart products.
      if (genderField) genderField.hidden = !isDualNow();

      if (seg) {
        seg.addEventListener("change", function () {
          seg.setAttribute("data-empty", "false");
          if (genderHint) genderHint.hidden = true;
        });
      }

      function open() {
        if (genderField) genderField.hidden = !isDualNow();
        lastFocus = document.activeElement;
        overlay.hidden = false;
        document.documentElement.classList.add("vl-sizedx-lock");
        trigger.setAttribute("aria-expanded", "true");
        modal.focus();
        document.addEventListener("keydown", onKey);
      }
      function close() {
        overlay.hidden = true;
        document.documentElement.classList.remove("vl-sizedx-lock");
        trigger.setAttribute("aria-expanded", "false");
        document.removeEventListener("keydown", onKey);
        if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
      }
      function onKey(e) { if (e.key === "Escape") close(); }

      var dismissBtn = root.querySelector('[data-role="dismiss"]');

      trigger.addEventListener("click", open);
      closeBtn.addEventListener("click", close);
      if (dismissBtn) dismissBtn.addEventListener("click", close);
      overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var m = currentModel();
        var isDual = m && m.genderMode === "dual";
        var h = form.height.value ? Number(form.height.value) : null;
        var w = form.weight.value ? Number(form.weight.value) : null;

        var g = null;
        if (isDual) {
          var checked = seg ? seg.querySelector('input:checked') : null;
          g = checked ? checked.value : null;
          if (!g) {
            if (seg) seg.setAttribute("data-empty", "true");
            if (genderHint) genderHint.hidden = false;
            var firstOpt = seg && seg.querySelector('input');
            if (firstOpt) firstOpt.focus();
          }
        }

        var r = recommendSize(m, { gender: g, heightCm: h, weightKg: w });
        result.querySelector('[data-role="size"]').textContent = r.size;
        result.querySelector('[data-role="message"]').textContent = r.message;
        var confMap = { good: "ぴったりの目安です", close: "近い目安です", outside: "目安の範囲外です" };
        result.querySelector('[data-role="confidence"]').textContent = confMap[r.confidence] || "";
        result.setAttribute("data-confidence", r.confidence);
        result.hidden = false;
        result.scrollIntoView({ block: "nearest", behavior: "smooth" });
      });

      redo.addEventListener("click", function () {
        result.hidden = true;
        form.height.focus();
      });

      root.__veluneReset = function () {
        result.hidden = true;
        if (form) form.reset();
        if (seg) seg.setAttribute("data-empty", "true");
        if (genderHint) genderHint.hidden = true;
        if (genderField) genderField.hidden = !isDualNow();
      };
    },
    initAll: function () {
      var roots = document.querySelectorAll("[data-vl-sizedx]");
      for (var i = 0; i < roots.length; i++) VeluneSizeDiagnosis.init(roots[i]);
    }
  };

  window.recommendSize = recommendSize;
  window.velune_msg = velune_msg;
  window.VeluneSizeDiagnosis = VeluneSizeDiagnosis;

  if (document.readyState !== "loading") VeluneSizeDiagnosis.initAll();
  else document.addEventListener("DOMContentLoaded", function () { VeluneSizeDiagnosis.initAll(); });

  // Re-init when the theme editor re-renders a section.
  document.addEventListener("shopify:section:load", function () { VeluneSizeDiagnosis.initAll(); });
  } catch(e) { console.error(e); }
})();

})();
